import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {ActivePlatformAlerts} from './all-alerts/active-platform-alerts';
import {CreateAlert} from './create-alert';
import {EditAlert} from './edit-alert';

export const PlatformAlertBuilderRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<ActivePlatformAlerts/>}/>
            <Route path="/create-alert" element={<CreateAlert/>}/>
            <Route path="/alert/:alertId" element={<EditAlert/>}/>

            <Route path="*" element={<Navigate to="/platform-alert-builder"/>}/>
        </Routes>
    );
};
